import {ReactNode} from 'react'
import './Typography.scss'

export const SecondaryTitle = ({title, children}: { title: string, children?: ReactNode }) => {
    return <h2 className="secondary-title" title={title}>{children ? children : title}</h2>
}